import { CommonModule, NgClass } from '@angular/common';
import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  computed,
  inject,
  input,
  output,
  signal
} from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { AuthService } from '../../../core/auth/auth.service';

type Notificacao = {
  id: number;
  titulo: string;
  mensagem: string;
  tempo: string;
  lida: boolean;
  tipo: 'info' | 'success' | 'warning';
};

@Component({
  selector: 'app-shell-header',
  standalone: true,
  imports: [
    CommonModule,
    NgClass,
    ButtonModule
  ],
  templateUrl: './shell-header.component.html',
  styleUrl: './shell-header.component.scss'
})
export class ShellHeaderComponent implements OnInit {
  collapsed = input(false);

  toggleMenu = output<void>();

  readonly visibleNotificacoes = signal(false);

  ngOnInit(): void {
  this.carregarNotificacoesFake();
}

  readonly notificacoes = signal<Notificacao[]>([
    {
      id: 1,
      titulo: 'Processamento concluído',
      mensagem: 'O lote de contratos foi processado com sucesso.',
      tempo: 'Agora mesmo',
      lida: false,
      tipo: 'success'
    },
    {
      id: 2,
      titulo: 'Atenção no sincronismo',
      mensagem: 'Um job demorou mais que o esperado na última execução.',
      tempo: 'Há 5 min',
      lida: false,
      tipo: 'warning'
    },
    {
      id: 3,
      titulo: 'Nova atualização',
      mensagem: 'O dashboard foi atualizado com os dados mais recentes.',
      tempo: 'Há 20 min',
      lida: true,
      tipo: 'info'
    }
  ]);

  private carregarNotificacoesFake(): void {
  this.notificacoes.set([
    {
      id: 1,
      titulo: 'Processamento concluído',
      mensagem: 'O lote de contratos foi processado com sucesso.',
      tempo: 'Agora mesmo',
      lida: false,
      tipo: 'success'
    },
    {
      id: 2,
      titulo: 'Atenção no sincronismo',
      mensagem: 'Um job demorou mais que o esperado.',
      tempo: 'Há 5 min',
      lida: false,
      tipo: 'warning'
    },
    {
      id: 3,
      titulo: 'Atualização disponível',
      mensagem: 'Novos dados foram sincronizados.',
      tempo: 'Há 20 min',
      lida: true,
      tipo: 'info'
    }
  ]);
}

  readonly naoLidas = computed(() =>
    this.notificacoes().filter(notificacao => !notificacao.lida).length
  );

  constructor(private readonly elementRef: ElementRef<HTMLElement>) {}

  private readonly authService = inject(AuthService);

  get usuarioLogado(): string {
    return this.authService.obterUsuarioLogado() ?? '';
  }

  onLogout(): void {
    this.authService.logout().subscribe();
  }

  onToggleMenu(): void {
    this.toggleMenu.emit();
  }

  toggleNotificacoes(): void {
    this.visibleNotificacoes.update(valor => !valor);
  }

  fecharNotificacoes(): void {
    this.visibleNotificacoes.set(false);
  }

  marcarComoLida(id: number): void {
    this.notificacoes.update(lista =>
      lista.map(notificacao =>
        notificacao.id === id
          ? { ...notificacao, lida: true }
          : notificacao
      )
    );
  }

  marcarTodasComoLidas(): void {
    this.notificacoes.update(lista =>
      lista.map(notificacao => ({ ...notificacao, lida: true }))
    );
  }

  getTipoClass(tipo: Notificacao['tipo']): string {
    switch (tipo) {
      case 'success':
        return 'tipo-success';
      case 'warning':
        return 'tipo-warning';
      default:
        return 'tipo-info';
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const alvo = event.target as Node | null;
    const clicouDentro = !!alvo && this.elementRef.nativeElement.contains(alvo);

    if (!clicouDentro && this.visibleNotificacoes()) {
      this.fecharNotificacoes();
    }
  }
}